import { ExternalChatUserStatus, isExternalChatUserStatus, } from "domain-entities";
import { CollectionPath } from "Configs/firebase";
import { useDocumentsOnceStore } from "Helpers/StoreHelper";
import { firestore } from "firebase/app";
import { useRef } from "react";

export function useUserStatusesOnceStore(
  organizationId: string,
  userIds: string[]
) {
  const collectionRef = useRef(
    firestore()
      .collection(CollectionPath.ORGANIZATIONS)
      .doc(organizationId)
      .collection(CollectionPath.USER_STATUSES)
  );

  return useDocumentsOnceStore<ExternalChatUserStatus>({
    collection: collectionRef.current,
    documentPaths: userIds,
    is: isExternalChatUserStatus,
    refreshTimeout: 1000 * 60
  });
}
